import {FC} from 'react';

import {useDispatch, useSelector} from '~/store/hooks';

import {ModalControlledProps} from './types';
import BaseModal from '../BaseModal/BaseModal';

export const ModalControlled: FC<ModalControlledProps> = ({id, onClose, ...rest}) => {
  const dispatch = useDispatch();
  const opened = useSelector((state) => state.modals[id].visible);

  const handleClose = () => {
    dispatch.modals.hideModal(id);

    if (onClose) {
      onClose();
    }
  };

  if (!opened) {
    return null;
  }

  return <BaseModal {...rest} opened={opened} onClose={handleClose} />;
};
